import { Button, Col, Form, Input, Row } from "antd";
import styles from "./Layout.module.scss";
import styled from "styled-components";
const CustomContainer = styled.div`
  /* اینجا استایل‌های مورد نظر خود را قرار دهید */
  background-color: #f0f0f0;
  padding: 20px;
  border-radius: 8px;
`;
const Layout = ({ children }) => {
  return (
    <Row justify={"center"} style={{ minHeight: "100%", padding: "3rem 0" }}>
      <style>
        {`
          #container {
            padding: 0;
          }
          body {
            background-color: #fafafa;
          }
        `}
      </style>
      <Col xxl={15} xl={20} lg={20} md={24} sm={24} xs={24} style={{ margin: "auto" }}>
        <Row>
          <Col xxl={10} xl={10} lg={24} sm={24} xs={24} className={styles.holderBgLoginForm}>
            <div className={styles.containerForm}>
              <div className={styles.holdLogo}>
                <img src={process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/logo.png"} />
              </div>
              <div className={styles.holdTitle}>
                <h2>سامانه مزایده سیم‌کارت‌های رند آپتل</h2>
              </div>
              <div className={styles.holddes}>
                <p> برای شرکت در مزایده، شماره موبایل خود را وارد کنید. شما می توانید با شماره موبایل تمامی اپراتورها وارد شوید.</p>
              </div>
              <div className={styles.holdForm}>{children}</div>
              <div className={styles.LinkHelper}>
                <a href={process.env.PUBLIC_URL + "/assets/files/Infographic.pdf"} download>
                  راهنمــای شــرکــت در مــزایـــده
                </a>
              </div>
            </div>
          </Col>
          <Col xxl={14} xl={14} lg={0} sm={0} xs={0} style={{ borderRadius: "0.25rem" }}>
            <div
              className={styles.holderImg}
              style={{
                borderRadius: "0.25rem",
                backgroundImage: `url('${process.env.PUBLIC_URL + process.env.REACT_APP_ROOT_PATH_FILE + "/assets/images/bg-login.jpg"}')`,
              }}
            ></div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Layout;
